<template>
<div class="points-address-add">
    <div class="form-item">
        <div class="form-label">收货人</div>
        <div class="form-input-box">
            <input class="form-input" placeholder="名字" v-model="form.receiver" maxlength="7" type="text" />
        </div>
    </div>
    <div class="form-item">
        <div class="form-label">手机号码</div>
        <div class="form-input-box">
            <div class="form-input-flex">
                <input class="form-input" placeholder="手机号码" v-model="form.phone" maxlength="11" type="number" />
            </div>
            <div class="v-center right-text">
                +86
                <img class="right-icon" src="../../assets/image/my-cell-icon-right.png" />
            </div>
        </div>
    </div>
    <div class="form-item" @click="modelShow = true">
        <div class="form-label">所在地区</div>
        <div class="form-input-box">
            <!-- <picker mode="multiSelector" range-key="name" range="{{multiArray}}" bindchange="bindMultiPickerChange" bindcolumnchange="bindMultiPickerColumnChange" value="{{multiIndex}}"> -->
                <div class="form-input-text">{{regionname}}</div>
                
            <!-- </picker> -->
        </div>
        <!-- <div class="v-center address-icon" bindtap="chooseLocation">
            <img class="address-right-icon" src="../../asstes/image/mall-position.png" />
        </div> -->
    </div>
    <div class="form-item">
        <div class="form-label">详细地址</div>
        <div class="form-input-box address-details">
            <textarea class="form-textarea" placeholder="小区楼栋/乡村名称" data-key="address" v-model="form.address"></textarea>
        </div>
    </div>
    <!-- <div class="form-item">
        <div class="form-label-inlink">设置默认收货地址</div>
        <div class="">
            <switch checked="{{switch}}" bindchange="switchChange"/>
        </div>
    </div> -->
    <div class="sub-box">
        <pi-button type="primary" block @click="addressClick">保存</pi-button>
    </div>

    <van-popup v-model="modelShow" position="bottom" >
      <van-picker value-key="name" @cancel="modelShow = false" @change="bindMultiPickerColumnChange"  @confirm="bindMultiPickerChange" show-toolbar title="请选择省市区" :columns="multiArray" />
    </van-popup>
</div>
</template>

<script>
import { addMyMallAddress,updMyMallAddress,getFindAreaList,detailMyMallAddress } from "../../common/api/index";
import {Picker, Popup, Switch  } from "vant";
export default {
  name: "points-goods-details",
  components: {
   [Picker.name]: Picker,
   [Popup.name]: Popup,
   [Switch.name]: Switch,
  },
  data() {
    return {
       form:{
        address:'',
        phone:'',
        receiver:'',
        regionId:'',
        pkid: ''
      },
      regionname: '省、市、区',
      multiArray: [
        // 第一列
        {
          values: [{name: '广东省',value: 1},{name: '广西省',value: 2}],
          defaultIndex: 2
        },
        // 第二列
        {
          values: [{name: '深圳市',value: 1},{name: '深圳市',value: 1},],
          defaultIndex: 1
        },
        // 第三列
        {
          values: [{name: '南山区',value: 1},{name: '罗湖区',value: 1},],
          defaultIndex: 1
        }
      ],
      switch: false,
      modelShow: false
    };
  },
  methods: {
    async detailMyMallAddress(){
      let ret = await detailMyMallAddress({addressPkId: this.form.pkid});
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.form.address = data.address;
        this.form.fullAddress = data.fullAddress;
        this.form.phone = data.phone;
        this.form.receiver = data.receiver;
        this.form.regionId = data.regionId;
        this.regionname = data.regionName? data.provinceName + data.cityName + data.regionName : this.regionname;
        let cityDataId = {
          provinceId: data.provinceId,
          cityId: data.cityId,
          regionId: data.regionId,
        }
        this.getFindAreaList(null,1,cityDataId);
      }

    },
    async addressClick(){
      let form = this.form;
      if(form.receiver == ''){
        this.$toast('请输入收货人姓名','none');
      }else if(form.phone == ''){
        this.$toast('请输入电话','none');
      }else if(form.phone.length!=11){
        this.$toast('请输入11位数的电话','none');
      }else if(form.regionId == ''){
        this.$toast('请选择所在地区','none');
      }else if(form.address == ''){
        this.$toast('请输入详细地址','none');
      }else{
        let ret;
        if(form.pkid == ''){
          ret = await addMyMallAddress(form);
        }else{
          form.pkId = form.pkid;
          ret = await updMyMallAddress(form);
        }
        if (ret.status === 0) {
          this.$toast('保存成功','success');
          this.$common.goBack();
        }else{
          this.toast(ret.msg,'none');
        }
      }
    },
    switchChange(e){
      console.log(e.detail.value)
    },
    async getFindAreaList(parentId,regionLevel,cityDataId){
      let ret = await getFindAreaList({parentId:parentId,regionLevel:regionLevel});
      if (ret.status === 0) {
        let multiArray = this.multiArray;
        if(regionLevel == 1){
          multiArray[0].values = ret.data;
          
          let value = ret.data[0].pkid;
          let defaultIndex = 0;

          if(cityDataId && cityDataId.provinceId){
            let index = ret.data.findIndex((item) => item.pkid == cityDataId.provinceId);
            if(index > 0){
              defaultIndex = index;
              value = cityDataId.provinceId
            }
          }
          multiArray[0].defaultIndex = defaultIndex;
          this.getFindAreaList(value,2,cityDataId)
        }else if(regionLevel == 2){
          multiArray[1].values = ret.data;

          let value = ret.data[0].pkid;
          let defaultIndex = 0;

          if(cityDataId && cityDataId.cityId){
            let index = ret.data.findIndex((item) => item.pkid == cityDataId.cityId);
            if(index > 0){
              defaultIndex = index;
              value = cityDataId.cityId
            }
          }

          multiArray[1].defaultIndex = defaultIndex;
          this.getFindAreaList(value,3,cityDataId)
        }else{
          multiArray[2].values = ret.data;
          let defaultIndex = 0;

          if(cityDataId && cityDataId.regionId){
            let index = ret.data.findIndex((item) => item.pkid == cityDataId.regionId);
            if(index > 0){
              defaultIndex = index;
            }
          }
           multiArray[2].defaultIndex = defaultIndex;
        }
        this.multiArray = multiArray;
        
      }
    },
    bindMultiPickerColumnChange: function (picker, value, index) {
      let parentId = value[index].pkid;
      if(index == 0){
        this.getFindAreaList(parentId,2);
      }else if(index == 1){
        this.getFindAreaList(parentId,3);
      }
    },
    
    bindMultiPickerChange: function (val) {
      this.form.regionId = val[2].pkid;
      this.regionname = val[0].name + val[1].name + val[2].name;
      this.modelShow = false;
    },
  },
  mounted() {
    let pkid = this.$route.query.pkid;
    if(pkid){
      this.form.pkid = pkid;
      this.detailMyMallAddress();
    }else{
      this.getFindAreaList(null,1)
    }
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.points-address-add{
    padding: 0 0.30rem;

  .form-item{
      display: flex;
      margin-top: 0.20rem;
      font-size: 0.28rem;
      line-height: 0.40rem;
  }
  .form-item:first-child{
    margin-top: 0;
  }
  .form-label{
      width: 1.46rem;
      color: #000000;
      padding: 0.27rem 0;
  }
  .form-input-box{
      display: flex;
      flex: 1;
      background: #FAFAFA;
      border-radius: 0.12px;
      height: 0.90rem;
      padding: 0.27rem 0.20rem;
      box-sizing: border-box;
  }
  .form-input-box.address-details{
      height: 2.20rem;
  }
  .form-input-flex{
      flex: 1;
  }
  .form-input,.form-textarea{
      width: 100%;
      background: transparent;
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #000000;
  }  
  .form-textarea{
      height: 1.80rem;

  }
  .right-icon{
      width: 0.12rem;
      height: 0.21rem;
  }
  .address-right-icon{
      width: 0.32rem;
      height: 0.39rem;
      
  }
  .sub-box{
      margin-top: 0.80rem;
  }
  .address-icon{
      padding: 0 0.20rem;
      background: #FAFAFA;
  }
  .form-label-inlink{
      color: #000000;
      flex: 1;
      line-height: 0.56rem;
  }
  .right-text{
      color: #666;
  }
  .form-input-text{
      min-width: 5.00rem;
  }
}
</style>
